import getCards from 'app/games/taboo/selectors/getCards';

export default function getCardsByDifficulty(state, difficultyId) {
  return getCards(state).filter(card => card.difficulty === difficultyId);
}
